import request from "@/CommonDP/utils/request";
export default {
  sysNoticeList(params) {
    return request.post(`/enterpriseNotice/list`, params)
      .then(res => res);
  },
  sysNoticeAdd(params) {
    return request.post(`/enterpriseNotice/add`, params)
      .then(res => res);
  },
  sysNoticeDelete(params) {
    return request.post(`/enterpriseNotice/delete`, params)
      .then(res => res);
  },
  sysNoticeDisable(params) {
    return request.post(`/enterpriseNotice/disable`, params)
      .then(res => res);
  },
  sysNoticeUpdate(params) {
    return request.post(`/enterpriseNotice/update`, params)
      .then(res => res);
  },
  sysNoticeGet(noticeId) {
    return request.get(`/enterpriseNotice/get?noticeId=` + noticeId)
      .then(res => res);
  }
};
